import Vue from 'vue';

export default () => {
  new Vue({
    el: '.profile-form',
    data: {
      name: '',
      thumbnailURL: '',
      comment: '',
      isLoading: false,
    },
    mounted() {
      const $view = $('.profiles-edit');
      const writer = $view.data('writer');
      if (writer.name) this.name = writer.name;
      if (writer.comment) this.comment = writer.comment;
      if (writer.thumbnail) this.thumbnailURL = writer.thumbnail;
    },
    methods: {
      fileSelected(e) {
        const files = e.target.files;
        if (!files.length) return;
        const fd = new FormData();
        this.isLoading = true;

        fd.append('image', files[0]);
        $.post({
          url: '/api/image/upload',
          type: 'POST',
          data: fd,
          processData: false,
          contentType: false,
        })
          .then((response) => {
            this.isLoading = false;
            this.thumbnailURL = response.url;
          })
          .catch((err) => {
            this.isLoading = false;
            console.error(err);
          });
      },
      update(e) {
        e.preventDefault();
      },
    },
  });
};
